import { render, staticRenderFns } from "./CreateWeighIn.vue?vue&type=template&id=535b002a&"
import script from "./CreateWeighIn.vue?vue&type=script&lang=js&"
export * from "./CreateWeighIn.vue?vue&type=script&lang=js&"
import style0 from "./CreateWeighIn.vue?vue&type=style&index=0&id=535b002a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports